<template lang="pug">
.contacts-listing__inner
	AppTable(:contacts="contacts")
</template>

<script>
import AppTable from "./Table.vue";

export default {
	name: "TableContainer",
  components: {
		AppTable,
  },
	props: {
		contacts: Array
	},
  data() {
    return {};
  },
	methods: {},
  created() {},
};
</script>

<style scoped lang="scss">
.contacts-listing {
	&__heading,
	&__sub-heading {
		display: inline-block;
	}
	&__heading {
		margin-right: 2rem;
	}
	&__sub-heading {
		color: $lightBlack;
	}
}
</style>